import type { Country } from '@/types/regionTypes';

import { Regions } from '@/layouts/Default/fixtures';

import { LocaleConfiguration } from './configuration/configuration';

export const getRegionList = () => {
  const supportedCountries =
    LocaleConfiguration.getInstance().getSupportedCountries();
  return Regions.data
    .map((region) => {
      const countries = supportedCountries?.filter(
        (item) => item.region === region.name,
      );

      return {
        ...region,
        countries,
      };
    })
    .filter((item) => item.countries.length > 0);
};

export const getCountrySelectorList = (
  countries: Country[],
  selectedCountry: Country,
) => {
  const favorites = countries.filter(
    (cty) => cty.favorite && cty.slug !== selectedCountry.slug,
  );
  const nonFavorites = countries.filter(
    (cty) => !cty.favorite && cty.slug !== selectedCountry.slug,
  );

  return [
    selectedCountry,
    ...(favorites.length ? [{}] : []),
    ...favorites,
    ...(nonFavorites.length ? [{}] : []),
    ...nonFavorites,
  ];
};
